"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("@app/request");
const set_employee_detail_1 = __importDefault(require("../action/set-employee-detail"));
const is_loading_1 = __importDefault(require("./is-loading"));
const store_1 = __importDefault(require("../store"));
const positions_1 = __importDefault(require("@app/request/positions"));
const moment_1 = __importDefault(require("moment"));
const util_1 = require("@app/util");
const create_ac_1 = require("./util/create-ac");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const loadEmployeeDetail = (0, create_ac_1.createAC)(async (dispatch, { user, silent, reload }) => {
    const { auth, workspaceId, workspaces, positions: wsPositions, employees, } = store_1.default.getState();
    const workspace = workspaces.find((ws) => ws.id === workspaceId);
    if (!workspaceId)
        return;
    if (!silent)
        void dispatch((0, is_loading_1.default)('employee-detail'));
    const vars = { user, workspace: workspaceId };
    let finalLocalities = [];
    let finalPositions = [];
    let finalRole = {};
    let finalEmployee = {};
    if (!reload && !!employees.length) {
        finalLocalities = workspace?.localities?.map(maybe_unwrap_1.unwrapMaybe).filter(util_1.isDefined) || [];
        finalPositions = wsPositions || [];
        const res = await (0, request_1.requestEmployeeDetail)(vars, false, auth);
        finalEmployee = { ...employees[user], ...res.user };
        finalRole = res || {};
    }
    else {
        finalLocalities = await (0, request_1.requestWorkspaceLocalities)({ workspaceId }, auth);
        finalPositions = await (0, positions_1.default)({ id: workspaceId });
        const res = await (0, request_1.requestEmployeeDetail)(vars, true, auth);
        finalEmployee = res?.user
            ? {
                ...res.user,
                contracts: res.contracts,
                employeeWarnings: res?.user?.workspaces?.find((ws) => ws.id === workspaceId)?.employeeWarnings?.length
                    ? res.user.workspaces.find((ws) => ws.id === workspaceId)
                        .employeeWarnings[0].warnings
                    : [],
            }
            : {};
        finalRole = res || {};
    }
    finalLocalities = Array.isArray(finalLocalities)
        ? finalLocalities.filter((loc) => loc.assigns?.some((ass) => ass.userId === user))
        : [];
    finalPositions = util_1.miscUtil.getPositionsOnRole(finalRole, (0, moment_1.default)());
    // workspace-specific, manager-given name in Role.customData can override the original user's name
    let customName = null;
    if (finalRole.customData &&
        (finalRole.customData.firstName || finalRole.customData.lastName)) {
        customName = [
            finalRole.customData.lastName || finalRole.user?.lastName,
            finalRole.customData.firstName || finalRole.user?.firstName,
        ]
            .filter((s) => !!s)
            .join(' ');
    }
    const employeeDetail = Object.assign({}, finalEmployee, {
        options: {
            customAttributes: finalRole.customAttributes,
            contract: finalRole.contract,
            vacationDays: finalRole.vacationDays,
            calendarOrder: finalRole.calendarOrder,
            cycleId: finalRole.cycleId,
            cycleGroup: finalRole.cycleGroup,
            accessRoles: finalRole.user?.accessRoles,
            contracts: finalEmployee.contracts,
        },
        employeeWarnings: finalEmployee.employeeWarnings,
        customData: finalRole.customData,
        terminateDate: finalRole.terminateDate,
        birthdate: finalRole.birthdate,
        terminalPIN: finalRole.terminalPIN,
        hidden: finalRole.hidden,
        name: customName || finalEmployee.name,
        localities: finalLocalities,
        positions: finalPositions,
    });
    dispatch((0, set_employee_detail_1.default)(employeeDetail));
    if (!silent)
        void dispatch((0, is_loading_1.default)('employee-detail', true));
    return employeeDetail;
});
exports.default = loadEmployeeDetail;
